import { createTheme, responsiveFontSizes } from "@mui/material/styles";

const headingFont = "'IBM Plex Serif', serif";
const bodyFont    = "'Inter', sans-serif";
const monoFont    = "'JetBrains Mono', 'Fira Code', ui-monospace, monospace";

let theme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#E2684A",
        },
        secondary: {
            main: "#7C3AED",
        },
        action: {
            active: "#22D3EE",
            hover: "#F472B6",
        },
        background: {
            default: "#030014",
            paper:   "#0F0728",
        },
        text: {
            primary:   "#E7E9EE", // INK — slightly softer than pure white
            secondary: "#B6BBC6", // INK2 — body text
        },
    },
    typography: {
        fontFamily: bodyFont,
        h1: { fontFamily: headingFont, fontWeight: 600, letterSpacing: "-0.02em" },
        h2: { fontFamily: headingFont, fontWeight: 600, letterSpacing: "-0.015em" },
        h3: { fontFamily: headingFont, fontWeight: 600, letterSpacing: "-0.01em" },
        h4: { fontFamily: headingFont, fontWeight: 600 },
        h5: { fontFamily: headingFont, fontWeight: 600 },
        h6: { fontFamily: headingFont, fontWeight: 600 },
        // subtitle2 re-purposed as the site-wide "Eyebrow" label variant
        subtitle2: {
            fontFamily: monoFont,
            fontSize: "11px",
            fontWeight: 500,
            letterSpacing: "0.16em",
            textTransform: "uppercase",
        },
        subtitle1: {
            fontFamily: bodyFont,
            fontWeight: 400,
            letterSpacing: "0.01em",
        },
        body1: { fontFamily: bodyFont, fontWeight: 400, lineHeight: 1.7 },
        body2: { fontFamily: bodyFont, fontWeight: 400, lineHeight: 1.65 },
        button: {
            fontFamily: monoFont,
            fontWeight: 500,
            textTransform: "none",
            letterSpacing: "0.02em",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "10px",
                    boxShadow: "none",
                    "&:hover": { boxShadow: "none" },
                },
                containedPrimary: {
                    background: "#E2684A",
                    color: "#1a0f0a",
                    "&:hover": {
                        background: "#e88564",
                    },
                },
                outlinedPrimary: {
                    borderColor: "#1E2130",
                    color: "#E7E9EE",
                    "&:hover": {
                        borderColor: "#E2684A",
                        color: "#E2684A",
                        background: "transparent",
                    },
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: `
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Serif:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');

        body {
          background-color: #030014;
          color: #E7E9EE;
        }

        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #030014; }
        ::-webkit-scrollbar-thumb { background: #1E2130; border-radius: 3px; }
        ::-webkit-scrollbar-thumb:hover { background: #2a2f45; }
      `,
        },
    },
});

theme = responsiveFontSizes(theme);

export default theme;
